var trans = {
	'test': 'foo es',
	'ENTRAR_UC': 'ENTRAR',
	'ATUALIZAR': 'Actualizar',
	'SAIR': 'Salir',
	'OBSERVACOES': 'Observaciones',
	'DEBITAR': 'Debitar',
	'CANCELAR': 'Cancelar',
	'ROUPA': 'Ropa',
	'RESUMO': 'Resumen',
	'AREA': 'Área',
	'COLABORADOR_A': 'Colaborador(a)',
	'QTD_QUARTOS': 'Cant. de Habitaciones',
	'TEMPO_TOTAL_MIN': 'Tiempo Total (min)',
	'ESTADO': 'Estado',
	'N_PESSOAS': 'Nº de Personas',
	'CAMAS_EXTRA': 'Camas supletorias',
	'NAO_INCOMODAR': 'No Molestar',
	'LIMPEZA_PRIORITARIA': 'Limpieza Prioritaria',
	'ESTADO_RESERVA': 'Estado de Reserva',
	'MUDAR_LENCOIS': 'Cambiar Sábanas',
	'NAO': 'No',
	'SIM': 'Sí',
	'BERCOS': 'Cunas',
	'NAO_LIMPAR': 'No Limpiar',
	'TEMPO_MIN': 'Tiempo (min)',
	'INICIO_UC': 'INICIO',
	'FIM_UC': 'FIN',
	'LIMPO_UC': 'LIMPIO',
	'ROUPA_UC': 'ROPA',
	'INSPECAO_UC': 'INSPECCIÓN',
	'PRECISA_DE_LIGACAO_A_INTERNET': 'Se necesita conexión a Internet para acceder a esta funcionalidad.',
	'RESERVAS_NO_POST': 'Las reservas "No Post" no permiten esta operación.',
	'OCORREU_UM_PROBLEMA_AO_TENTAR': 'Se ha producido un problema al intentar enviar el mensaje.',
	'LIMPO_C_ENTRADA': 'Limpiado con Entrada',
	'LIMPO': 'Limpio',
	'SAIDA_C_ENTRADA': 'Salida con Entrada',
	'SUJO_C_ENTRADA': 'Sucio con Entrada',
	'SAIDA': 'Salida',
	'OCUPADO': 'Ocupado',
	'SUJO': 'Sucio',
	'SUJA': 'Sucia',
	'EM_FALTA': 'Faltante',
	'TOTAL': 'Total',
	'ARTIGO': 'Artículo',
	'QTD': 'Cant.',
	'CONSUMO': 'Consumo',
	'QUEBRA': 'Rotura',
	'EXISTEM_ALTERACOES_NOS_CONSUMOS': 'Hay cambios en los consumos de la habitación.',
	'EXISTEM_ALTERACOES_NAS_QUEBRAS': 'Hay cambios en las roturas del cuarto.',
	'PRETENDE_AVANCAR': '¿Desea avanzar?',
	'ESTADO_DO_QUARTO': 'Estado de la Habitación',
	'AVALIACAO': 'Evaluación',
	'AVALIACAO_GERAL': 'Evaluación General',
	'AVALIACAO_MANUTENCAO': 'Mantenimiento',
	'AVALIACAO_LIMPEZA': 'Limpieza',
	'INSPECIONADO': 'Inspeccionado',
	'O_CAMPO_AVALIACAO_E_OBRIGATORIO': 'El campo Evaluación General es obligatorio.',
	'O_CAMPO_MANUTENCAO_E_OBRIGATORIO': 'El campo Mantenimiento es obligatorio.',
	'O_CAMPO_LIMPEZA_E_OBRIGATORIO': 'El campo Limpieza es obligatorio.',
	'QUANTIDADE': 'Cantidad',
	'NAO_EXISTE_ROUPA_ATRIBUIDA_PARA': 'No hay ropa asignada para esta área.',
	'BLOCO': 'Bloque',
	'PISO': 'Piso',
	'N_QUARTO': 'Nº de Habitación',
	'ESTADO_LIMPEZA': 'Estado de Limpieza',
	'QUARTOS': 'Habitaciones',
	'AVISO': 'Aviso',
	'ERRO': 'Error',
	'PESQUISA' : 'Buscar',
	'REGIME': 'Régimen',
	'CONFIRMAR': 'Confirmar',
	'AVANCAR': 'Avanzar',
	'INSPECTION_NOT_SAVED_NO_INTERNET': 'La inspección no se guardó. Sin conexión a Internet.',
	'BREAKING_NOT_SAVED_NO_INTERNET': 'Débito de minibar no guardado. Sin conexión a Internet.',
	'ESTADO_QUARTO': 'Estado Habitación',
	'PESQUISAR': 'Buscar',
	'FECHAR': 'Cerrar',
	'RESET': 'Reset',
	'RESERVA': 'Reserva',
	'ADULTOS': 'Adultos',
	'CRIANCAS_4_12': 'Niños 4-12',
	'CRIANCAS_0_3': 'Niños 0-3',
	'NAO_NO_SHOW': 'No se encontraron reservas con el estado "No Show".',
	'REPORT': 'Informe',
	'NO_SHOW': 'No Show',
	'TIPOLOGIA': 'Tipología',
	'HORA_INSPECAO_GOVERNANTA': 'Hora de Inspección de Gobernanta',
	'HORA_INSPECAO_DIRECAO': 'Hora de Inspección de Dirección',
	'INSPECAO_GOVERNANTA': 'Inspección de Gobernanta',
	'INSPECAO_DIRECAO': 'Inspección de Dirección',
	'O_CAMPO_OBSERVACAO_E_OBRIGATORIO': 'El campo \'Observaciones de la Habitación\' es obligatorio para el estado de la habitación \'Mantenimiento/Bloqueado\'',
	'OBSERVACOES_QUARTO': 'Observaciones de la Habitación',
	'OBSERVACOES_INSPECAO': 'Observaciones de Inspección',
}
module.exports = trans;